import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-exemption-request-submission',
  templateUrl: './exemption-request-submission.component.html',
  styleUrls: ['./exemption-request-submission.component.css']
})
export class ExemptionRequestSubmissionComponent implements OnInit {

  questions: SurveyQuestionVm[];
  constructor(private surveyServiceProxy: SurveyService,) { }

  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    this.questions = await this.surveyServiceProxy.getExemptionRequestSubmissionQuestions().toPromise();
    console.log(this.questions);
  }

}
